<template>
    <div class="modal-access">
        <div class="modal-access__wrapper">
            <div class="modal-access__header">
                <IconSpeaker class="modal-access__speaker" @click="speechSynthesis(text)"></IconSpeaker>
                <p class="modal-access__title">{{ text }}</p>
            </div>
            <p class="modal-access__subtitle">Zalogowanie i utworzenie profilu dziecka, umożliwi Ci dostęp do wszystkich funkcjonalności Krainy ABC, Między innymi:</p>
            <ul class="modal-access__list">
                <li class="modal-access__list-item">dodawanie materiałów do ulubionych</li>
                <li class="modal-access__list-item">dostosowanie tresci do wieku dziecka</li>
                <li class="modal-access__list-item">możliwość korzystania z panelu rodzicielskiego i wglądu do ostatnich aktywności dziecka.</li>
            </ul>
            <div class="modal-access__btns">
                <button class="modal-access__btn modal-access__reject" @click="closeHandle">Pomiń</button>
                <button class="modal-access__btn modal-access__confirm" @click="login">Zaloguj się</button>
            </div>

            <i class="modal-access__letter"></i>
            
            <IconClose class="modal-access__close close" @click="closeHandle"></IconClose>
        </div>
    </div>
</template>

<script>
import IconClose from "../elements/icons/IconClose.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";

export default {
    name: "ModalAccess",
    components: {
        IconClose,
        IconSpeaker
    },
    data() {
        return {
            text: "Zaloguj się, aby otrzymać pełny dostęp"
        }
    },
    methods: {
        closeHandle() {
            this.$store.dispatch("changeModalAccessState");
            this.$store.dispatch("changeModalBackdrop", false);
        },
        login() {
            this.$store.dispatch("changeModalAccessState");
            this.$store.dispatch("changeModalLoginState", true);
        }
    }
}
</script>
